export const ADD_LOGIN_DATA = 'ADD_LOGIN_DATA';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const RESET_LOGIN_DATA ='RESET_LOGIN_DATA';
